<template>
    <fieldset v-if="itemList.length>0 || readOnly!=true" class="fieldset mx-0 mb-3">
        <legend class="legend">چک لیست</legend>
        <button :disabled="saveLoading"
                v-if="readOnly!=true"
                class="btn btn-xxs btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="addNewFolder()">
            <i class="fa fa-plus font-14 ml-1"></i>
            افزودن آیتم
        </button>

        <div v-if="itemList.length>0">
            <div v-if="readOnly">
                <div class="d-flex align-items-center checkLList-list px-2" v-for="element in itemList" :key="element.TaskFolderItemId">
                    <div class="d-flex align-items-center" style="min-width: 70%">
                        <input type="checkBox" :checked="element.done === true" disabled />
                        <div class="mr-3 py-2 d-flex align-items-start flex-column justify-content-center">
                            <del v-if="element.done === true" class="text-muted">
                                {{element.title}}
                            </del>
                            <span v-else class="font-weight-bold">
                                {{element.title}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <draggable v-model="itemList" item-key="taskFolderItemId" @change="sortFolders" handle=".btn-drag">
                    <template #item="{ element }">
                        <div class="d-flex align-items-center checkLList-list px-2">
                            <div class="btn-drag" style="min-width: 6%">
                                <i class="fa fa-grip-vertical"></i>
                            </div>
                            <div class="d-flex align-items-center"
                                 style="min-width: 70%"
                                 @click="setAsDone(element)">
                                <input type="checkBox" :checked="element.done === true" :disabled="readOnly == true" />
                                <div class="mr-3 py-2 d-flex align-items-start flex-column justify-content-center ">
                                    <del v-if="element.done === true" class="text-muted">
                                        {{ element.title }}
                                    </del>
                                    <span v-else class="font-weight-bold">
                                        {{ element.title }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="element.editable && readOnly!=true" style="min-width:26%" class="text-left">
                                <div class="badge bg-blue2-light mt-0 px-2 py-2"
                                     @click="setEditing(element)">
                                    <b class="fa fa-edit"></b>
                                </div>
                                <div class="badge bg-red2-dark mt-0 px-2 py-2 mr-1"
                                     @click="removeFolder(element)">
                                    <b class="fa fa-trash"></b>
                                </div>
                            </div>
                        </div>
                    </template>
                </draggable>
            </div>
        </div>
        <taskFolderItem-modal v-if="showFolderModal" @close="showFolderModal = false" :taskFolderItem="selectedFolder" @saveFolder="saveFolderChanges"></taskFolderItem-modal>
    </fieldset>
</template>
<script>
    import VueSimpleAlert from "vue3-simple-alert";
    import draggable from "vuedraggable";
    import folderModal from "./TaskFolderItemModal.vue";
    export default {
        components: {
            draggable,
            "taskFolderItem-modal": folderModal,
        },
        props: ["taskId", "taskFolderId", "readOnly"],
        data() {
            return {
                modified: false,
                pageLoaded: false,
                saveLoading: false,
                showFolderModal: false,
                selectedFolder: null,
                itemList: [],
            };
        },
        mounted() {
            if (this.taskFolderId != 0) {
                this.GetTaskFolderItem(this.taskFolderId);
            }
        },
        methods: {
            addNewFolder() {
                var obj = {
                    title: null,
                    done: false,
                    editable: true,
                    disabled: false,
                    edited: false,
                    editing: true,
                    taskFolderItemTempId: 0,
                    taskFolderItemId: 0,
                    taskFolderId: 0,
                    userId: 0,
                    seq: this.itemList.length + 1,
                };
                this.selectedFolder = obj;

                this.showFolderModal = true;
            },
            saveFolderChanges(c) {
                this.saveLoading = true;
                c.taskFolderId = this.taskFolderId;
                console.log(c);
                c.done = c.done === "true" || c.done === true;
                if (this.taskFolderId == 0) {
                    if (c.taskFolderItemTempId == 0) {
                        c.taskFolderItemTempId = Math.floor(Math.random() * 100) + 1;
                        this.itemList.push(c);
                    }

                    this.$emit("setFolderItemList", this.itemList);
                    this.showFolderModal = false;
                    this.saveLoading = false;
                } else {
                    this.$http.post("task/SaveItemFolder", c).then((data) => {
                        this.saveLoading = false;
                        if (isNaN(data.data)) {
                            this.showMessage(data.data);

                        } else {
                            this.showSuccessMessage("با موفقیت ذخیره شد.");
                            this.showFolderModal = false;
                            this.GetTaskFolderItem(this.taskFolderId);
                        }
                    });
                }
            },
            GetTaskFolderItem(id) {
                this.$http
                    .get("task/GetTaskFolderItemList?taskFolderId=" + id)
                    .then((data) => {
                        this.itemList = data.data;
                        this.modified = false;
                    });
            },
            setEditing(c) {
                c.editing = true;
                this.selectedFolder = c;
                this.showFolderModal = true;
            },
            removeFolder(c) {
                VueSimpleAlert.confirm(
                    "آیا مایل به حذف این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {
                    c.title = null;
                    if (c.taskFolderItemId != 0) {
                        this.$http
                            .get("Task/DeleteTaskFolderItem?id=" + c.taskFolderItemId)
                            .then((data) => {
                                var res = data.data.toString();
                                if (res === "1") {
                                    this.showSuccessMessage("با موفقیت حذف شد.");
                                    this.GetTaskFolderItem(this.taskFolderId);
                                } else {
                                    this.showErrorMessage(res);
                                }
                            });
                    } else {
                        const index = this.itemList.indexOf(c);
                        if (index > -1) {
                            this.itemList.splice(index, 1);
                            this.$emit("setFolderItemList", this.itemList);
                        }
                    }
                });
            },
            setAsDone(c) {
                if (this.readOnly) {
                    return;
                }
                c.done = c.done === "true" || c.done === true;
                c.done = !c.done;
                if (this.taskFolderId == 0) {
                    this.saveFolderChanges(c);
                } else {
                    this.$http.get("Task/SaveDoneValue?id=" + c.taskFolderItemId + "&value=" + c.done)
                        .then((data) => {
                            var res = data.data.toString();
                            if (res === "1") {
                                this.showSuccessMessage("با موفقیت ثبت شد.");
                            } else {
                                this.showErrorMessage(res);
                                if (this.taskFolderId != 0) {
                                    this.GetTaskFolderItem(this.taskFolderId);
                                }
                            }
                        });
                }
            },
            setShowFolderModal() {
                this.showFolderModal = true;
            },
            sortFolders() {
                //this.checkListModel.done = (this.checkListModel.done === 'true' || this.checkListModel.done === true);
                var idList = this.itemList.map((x) => x.taskFolderItemId);
                if (this.taskFolderId == 0) {
                    this.$emit("setFolderItemList", this.itemList);
                } else {
                    this.$http.post("task/SortFolderItems", idList).then((response) => {
                        this.saveLoading = false;
                        console.log(response);
                    });
                }
            },
        },
    };
</script>
